import { useNavigate } from 'react-router-dom'
import { Crown, BarChart3, TrendingUp, PieChart, Vote } from 'lucide-react'

const sections = [
  { title: 'Histórico de Eleições', description: 'Inteligência eleitoral — resultados por zona, seção, bairro e candidato', icon: Vote, path: '/reports/elections', highlight: true },
  { title: 'Ranking de Lideranças', description: 'Desempenho, captação e metas por liderança', icon: Crown, path: '/reports/leaders' },
  { title: 'Crescimento', description: 'Evolução de cadastros ao longo do tempo', icon: TrendingUp, path: '/reports/growth', soon: true },
  { title: 'Demográfico', description: 'Perfil por gênero, faixa etária e região', icon: PieChart, path: '/reports/demographics', soon: true },
  { title: 'Campanhas', description: 'Comparativo de desempenho entre campanhas', icon: BarChart3, path: '/reports/campaigns', soon: true },
]

export default function ReportsOverviewPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Relatórios</h1>
        <p className="text-gray-500 mt-1">Analise dados e acompanhe o desempenho</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {sections.map(section => {
          const Icon = section.icon
          return (
            <div
              key={section.title}
              onClick={() => !section.soon && navigate(section.path)}
              className={`bg-white rounded-2xl border p-6 transition-shadow ${section.soon ? 'opacity-60 cursor-default border-gray-200' : section.highlight ? 'border-brand-200 bg-brand-50/30 hover:shadow-md cursor-pointer ring-1 ring-brand-100' : 'border-gray-200 hover:shadow-sm cursor-pointer'}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-brand-50 text-brand-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-gray-800">{section.title}</h3>
                    {section.soon && <span className="text-[10px] font-bold text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">EM BREVE</span>}
                  </div>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
